module.exports = __webpack_public_path__ + "img/about-patent4.52dd5f2.png";